/**
 * Factory function for initializing the MSAL instances during app startup
 */
import { MsalInitializerService } from './_shared/services/authentication/msal-initializer.service';
import { RuntimeConfigService } from './_shared/services/config/runtime-config.service';

export function initializeMsalInstances(
  msalInitializer: MsalInitializerService,
  runtimeConfigService: RuntimeConfigService
): () => Promise<void> {
  return async () => {
    try {
      console.log('[App Initialization] Starting MSAL instances initialization');
      
      // Make sure the configuration is available
      // Note: config should already be loaded by the time this runs
      // since the APP_INITIALIZER for config runs first
      if (!runtimeConfigService.config) {
        console.log('[App Initialization] Waiting for runtime config to load');
        // If config isn't available yet, load it
        await runtimeConfigService.loadConfig();
      }
      
      // The actual MSAL initialization will happen in the login services
      console.log('[App Initialization] Runtime config loaded, MSAL instances will initialize on first use');
      
    } catch (error) {
      console.error('[App Initialization] Error during MSAL initialization:', error);
    }
  };
}
